// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + {399: "jd-core-syntax-highlight",592: "jd-core-search-index",743: "jd-core-decompiler",}[chunkId] + "." + {399: "935cd932",592: "9691f231",743: "f1348eaa",}[chunkId] + ".js"
}